<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('wafevent.pageTitleText')}}

        Tabs(v-model="currentTab")
            template(v-for="(tab,index) in tabItems" v-if="index<=1")
                TabPane(:label="$t(`wafevent.${tab.name}`)" :name="tab.name")
                    div
                        RcmTable(
                            v-if="currentTab==tab.name"
                            :esIndex="tab.esIndex"
                            :esIndexFields="esIndexFields"
                            :addButtonText="addButtonText"
                            :userCanAdd="userCanAdd"
                            :sort="sort"
                            ref="rcmTable"
                            :searchView="$options.name"
                            primarySearchKey="req_id"
                            :primarySearchKeyI18="$t('wafevent.req_id')"
                            :isFuzzySearch="false"
                            :rowClassInfo="rowClassInfo"
                            :isSearchAfterBtnEnabled="isSearchAfterBtnEnabled")
            //- //增加RealTimeData的tab(增加v-if控制v-for loop的範圍)
            //- template(v-for="(tab,index) in tabItems" v-if="index>1")
            //-     TabPane(:label="$t(`wafevent.${tab.name}`)" :name="tab.name")
            //-         //要選group才可以瀏覽資料
            //-         template(v-if="$store.state.queryGroupName == 'all'")
            //-             Card
            //-                 div(style="text-align: center")
            //-                     h3 {{ $t('wafevent.queryGroupNameCard')}}
            //-         template(v-else)
            //-             Card(style="min-height:200px")
            //-                 div(style="display:flex;justify-content:space-between")
            //-                     GroupNameSelector(style="width:25%" @updateGroupValue="updateGroupName")
            //-                     EdgeNameSelector(style="width:25%" @updateEdgeValue="updateEdgeName")
            //-                     TimeSelector(style="width:25%" @updateTimeValue="updateTime")
            //-                     CountSelector(style="width:25%" @updateCountValue="updateCount")
            //-                     Button(v-on:click="filterRealTimeData") {{ $t("rcmtable.search")}}
            //-                 template(v-for="data in realTimeDataset")
            //-                     div(style="padding:8px 0;border-bottom:1px solid #e8eaec") {{data}}
</template>
<script>
import Vue from "vue";
Vue.component("JsonPoptip", JsonPoptip);

import RcmTable from "@/components/RcmTable_v2";
import JsonPoptip from "@/components/JsonPoptip";
// import GroupNameSelector from "@/components/FormItems/GroupNameSelector";
// import EdgeNameSelector from "@/components/FormItems/EdgeNameSelector";
// import TimeSelector from "@/components/FormItems/TimeSelector";
// import CountSelector from "@/components/FormItems/CountSelector";

import { status, scheme } from "./fields.js";
// import { getLogFromEdge } from "@/api/edges";

export default {
    name: "WafEvent",
    components: {
        RcmTable,
        JsonPoptip,
        // GroupNameSelector,
        // EdgeNameSelector,
        // TimeSelector,
        // CountSelector,
    },
    data() {
        return {
            currentTab: "originData",
            tabItems: [
                { name: "originData", esIndex: "rcm-monitor-edge-accesslog-*" },
                { name: "samplingData", esIndex: "rcm-monitor-edge-accesslogsampling-*" },
                //{ name: "realTimeData" }, //這個tab的資料是直接接EDGE
            ],
            // esIndex: "rcm-monitor-edge-accesslog-*",
            addButtonText: "",
            userCanAdd: false,
            sort: [{ timestamp: { order: "desc" } }, { "@timestamp": { order: "desc" } }],
            rowClassInfo: {
                key: "",
                values: [],
                valuesNot: [],
                className: "",
                defaultClassName: "",
            },
            generalFields: [],
            // realTimeDataset: [],
            // selectGroupName: [],
            // selectEdgeName: [],
            // selectTime: [],
            // selectCount: [],
        };
    },
    computed: {
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      req_id: {},
                      server_name: {},
                      timestamp: {},
                      group: {},
                      servicegroup: {},
                      host: {},
                      tb_action: {},
                      //   period_button: {},
                      tb_type: {},
                      tb_rule: {},
                      tb_reason: {},
                      cus_realy_addr: {},
                      country: {},
                      request_method: {},
                      status: status(this),
                      scheme: scheme(this),
                      server_port: {},
                      uri: {},
                      args: {},
                      request_url: {},
                      req_headers: {},
                      request_time: {},
                      upstream_response_time: {},
                      upstream_status: {},
                      server_protocol: {},
                      proxyType: {},
                      isp: {},
                      originHostResolve: {},
                      raw_uri: {},
                      raw_args: {},
                      ssl_ja3: {},
                      ssl_ja3_hash: {},
                  }
                : {
                      req_id: {},
                      server_name: {},
                      timestamp: {},
                      group: {},
                      servicegroup: {},
                      tb_action: {},
                      //   period_button: {},
                      //   tb_type: {},
                      tb_rule: {},
                      tb_reason: {},
                      cus_realy_addr: {},
                      country: {},
                      request_method: {},
                      status: status(this),
                      scheme: scheme(this),
                      server_port: {},
                      uri: {},
                      args: {},
                      request_url: {},
                      req_headers: {},
                      request_time: {},
                      upstream_response_time: {},
                      upstream_status: {},
                      server_protocol: {},
                      proxyType: {},
                      isp: {},
                      originHostResolve: {},
                      raw_uri: {},
                      raw_args: {},
                      ssl_ja3: {},
                      ssl_ja3_hash: {},
                  };
        },
        isSearchAfterBtnEnabled() {
            return this.currentTab == "originData";
        },
    },
    created() {
        // this.getRealTimeData();
    },
    methods: {
        // async getRealTimeData() {
        //     await getLogFromEdge({ group: this.$store.state.queryGroupName })
        //         .then((res) => {
        //             this.realTimeDataset = res.data.message;
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // },
        // updateGroupName(value) {
        //     this.selectGroupName = value;
        // },
        // updateEdgeName(value) {
        //     this.selectEdgeName = value;
        // },
        // updateTime(value) {
        //     if (value === null) {
        //         this.selectTime = [];
        //     } else {
        //         this.selectTime = value;
        //     }
        // },
        // updateCount(value) {
        //     if (value === null) {
        //         this.selectTime = [];
        //     } else {
        //         this.selectCount = value;
        //     }
        // },
        // filterRealTimeData() {
        //     getLogFromEdge({
        //         group: this.selectGroupName,
        //         hostname: this.selectEdgeName,
        //         time: this.selectTime,
        //         count: this.selectCount,
        //     })
        //         .then((res) => {
        //             this.realTimeDataset = [
        //                 `後端建置
        //                 edge名稱=${this.selectEdgeName}
        //                 time=${JSON.stringify(this.selectTime)}
        //                 count=${JSON.stringify(this.selectCount)}的資料中`,
        //             ];
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // },
    },
    mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/view/WafEvent/Page.vue